<template>
  <b-col :class="customClass">
    <div class="card" :class="sensorActive ? 'bg-primary' : ''">
      <div class="card-body d-flex justify-content-between align-items-center p-1">
        <div :class="sensorActive ? 'w-100 ' : 'w-75 '" class="cursor-pointer" @click="modalOrder">
          <h4 v-if="!sensorActive" :class="sensorActive ? 'text-white' : ''" class="mb-25 font-weight-bolder">{{ msisdn }}</h4>
          <h2 v-if="sensorActive" :class="sensorActive ? 'text-white ' : ''" class="mb-25 font-weight-bolder">{{ msisdn }}</h2>
          <span  v-if="sensorActive"  :class="sensorActive ? 'text-white text-bold' : ''" class="text-ellipsis font-medium-2 font-weight-bolder overflow-hidden d-block ">{{ price }} TJS. | {{ this.category }}</span>
          <span v-if="!sensorActive"  :class="sensorActive ? 'text-white text-bold' : ''" class="text-ellipsis overflow-hidden d-block ">{{ price }} TJS. <br> {{ this.category }}</span>
        </div>
        <span v-if="!sensorActive" class="b-avatar w-25 cursor-pointer" style="min-width: 35px; height: 35px;">
        <span class="b-avatar-custom">
        <feather-icon icon="BookmarkIcon" @click="Save" :class="statusSaved ? 'text-primary' : 'text-black-50'"
                      size="23" :fill="statusSaved ? '#2d2e9b' : '#fff'" v-if="!sensorActive"/>
        </span>
      </span>
      </div>
    </div>
  </b-col>
</template>

<script>
import { BCol } from 'bootstrap-vue'
import VueCookies from 'vue-cookies'

export default {
  name: 'Number',
  components: {
    BCol,
  },
  data() {
    return {
      statusSaved: false,
      sensorActive: false,
    }
  },
  methods: {
    modalOrder() {
      if (!this.sensorActive) {
        this.$emit('modalOrder', this.msisdn, this.category, this.price)
      }
    },
    callSavedFromOut() {
      this.Saved()
    },
    Saved() {
      const saved = VueCookies.get('saved')
      if (saved && saved[this.msisdn]) {
        this.statusSaved = true
      } else {
        this.statusSaved = false
      }
    },
    async Save() {
      const saved = VueCookies.get('saved')
      let n = saved
      if (!n || n === '' || n === null) {
        n = {}
      }

      if (n && n[this.msisdn]) {
        delete n[this.msisdn]
      } else {
        n[this.msisdn] = {
          level_name: this.category,
          level_price: this.price,
        }
      }
      await VueCookies.set('saved', n)
      this.$emit('onSaved', this.msisdn)
      this.Saved()
    },
  },
  props: {
    msisdn: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    customClass: {
      type: String,
      required: true,
    },
  },
  created() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
    } else {
      this.sensorActive = false
      this.Saved()
    }
  },
  updated() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
    } else {
      this.sensorActive = false
      this.Saved()
    }
  },
}
</script>

<style scoped>

.card {
  border-radius: 1.2rem;
}

.card-body {
  padding: 10px 15px !important;
}

.card-body span {
  font-size: 13px;
}
.sensorActive .card {
  -webkit-box-shadow: 2px 2px 6px 3px rgb(34 41 47 / 30%);
  box-shadow: 2px 2px 6px 3px rgb(34 41 47 / 30%);
  border-radius: 0.428rem;
}
.card-body span.text-ellipsis {
  color: #6c6b6f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100px;
}
h4{
  font-size: 1.15rem !important;
}
@media (max-width: 767.98px) {
  .card-body {
    padding: 7px 12px !important;
  }
  h4{
    font-size: 1rem !important;
  }
}
</style>
